module.exports = __webpack_public_path__ + "img/logo-installment-KBANK.7a0f9eec.png";